import * as React from 'react';

import { default as SvgIcon } from './SvgIcon.js';

/**
 * Autogenerated react component for icon MeetingDuotone
 */
export const MeetingDuotone = React.forwardRef((props: any, ref: any) => (
  <SvgIcon
    ref={ref}
    viewBox="0 0 256 256"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <style type="text/css">{'.st0{opacity:0.2;}'}</style>
    <path
      d="M98.5,16.7c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3S86.3,35.8,86.3,29c0,0,0,0,0,0 C86.3,22.2,91.7,16.8,98.5,16.7 M98.5,6.7c-12.3,0-22.2,10-22.2,22.2s10,22.3,22.2,22.3s22.2-10,22.2-22.3S110.8,6.7,98.5,6.7z"
      fill="currentColor"
    />
    <path
      d="M37.5,67.8c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3S25.3,86.8,25.3,80c0,0,0,0,0,0 C25.3,73.2,30.7,67.8,37.5,67.8 M37.5,57.8c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2l0,0 C59.8,67.7,49.8,57.8,37.5,57.8C37.5,57.8,37.5,57.8,37.5,57.8z"
      fill="currentColor"
    />
    <path
      d="M37.5,115.8c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C25.3,121.2,30.7,115.8,37.5,115.8 M37.5,105.8c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2l0,0 C59.8,115.7,49.8,105.8,37.5,105.8z"
      fill="currentColor"
    />
    <path
      d="M37.5,163.8c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C25.3,169.2,30.7,163.8,37.5,163.8 M37.5,153.8c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2l0,0 C59.8,163.7,49.8,153.8,37.5,153.8z"
      fill="currentColor"
    />
    <path
      d="M218.5,67.8c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C206.3,73.2,211.7,67.8,218.5,67.8 M218.5,57.8c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2l0,0 C240.8,67.7,230.8,57.8,218.5,57.8z"
      fill="currentColor"
    />
    <path
      d="M218.5,115.8c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C206.3,121.2,211.7,115.8,218.5,115.8 M218.5,105.8c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2l0,0 C240.8,115.7,230.8,105.8,218.5,105.8z"
      fill="currentColor"
    />
    <path
      d="M218.5,163.8c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C206.3,169.2,211.7,163.8,218.5,163.8 M218.5,153.8c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2l0,0 C240.8,163.7,230.8,153.8,218.5,153.8z"
      fill="currentColor"
    />
    <path
      d="M155.5,16.7c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C143.3,22.2,148.7,16.8,155.5,16.7 M155.5,6.7c-12.3,0-22.2,10-22.2,22.2s10,22.3,22.2,22.3s22.2-10,22.2-22.3S167.8,6.7,155.5,6.7z "
      fill="currentColor"
    />
    <path
      d="M98.5,214.8c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C86.3,220.2,91.7,214.8,98.5,214.8 M98.5,204.8c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2 S110.8,204.8,98.5,204.8L98.5,204.8z"
      fill="currentColor"
    />
    <path
      d="M155.5,214.8c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C143.3,220.2,148.7,214.8,155.5,214.8 M155.5,204.8c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2 S167.8,204.8,155.5,204.8L155.5,204.8z"
      fill="currentColor"
    />
    <path d="M178.3,65.5v123h-97v-123H178.3 M188.3,55.5h-117v143h117V55.5z" fill="currentColor" />
    <path
      className="st0"
      d="M98.5,16.7c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3S86.3,35.8,86.3,29c0,0,0,0,0,0 C86.3,22.2,91.7,16.8,98.5,16.7"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M37.5,67.8c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3S25.3,86.8,25.3,80c0,0,0,0,0,0 C25.3,73.2,30.7,67.8,37.5,67.8"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M37.5,115.8c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C25.3,121.2,30.7,115.8,37.5,115.8"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M37.5,163.8c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C25.3,169.2,30.7,163.8,37.5,163.8"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M218.5,67.8c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C206.3,73.2,211.7,67.8,218.5,67.8"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M218.5,115.8c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C206.3,121.2,211.7,115.8,218.5,115.8"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M218.5,163.8c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C206.3,169.2,211.7,163.8,218.5,163.8"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M155.5,16.7c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C143.3,22.2,148.7,16.8,155.5,16.7"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M98.5,214.8c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C86.3,220.2,91.7,214.8,98.5,214.8"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M155.5,214.8c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C143.3,220.2,148.7,214.8,155.5,214.8"
      fill="currentColor"
    />
    <path className="st0" d="M178.3,65.5v123h-97v-123H178.3" fill="currentColor" />
  </SvgIcon>
)) as React.FC<React.ComponentPropsWithRef<typeof SvgIcon>>;

export default MeetingDuotone;
